import partner from '../../fields/other/partner';

export const MUTATION_UPDATE_PARTNER = /* GraphQL */ `
	mutation($id: String!, $input: PartnerUpdate!) {
		updatePartner(id: $id, input: $input) {
			${partner}
		}
	}
`;
